module.exports = __webpack_public_path__ + "f3a446e58b2dad5019da01064bee726d.woff";